import { useState } from 'react';
import CommanModal from '../CommanModal';
import { useSelector } from 'react-redux';
import { renderDescriptionParagraphs } from '@rb-serve-app/core';

const ChangePinInfoModal = ({
  isOpen,
  onClose,
  currentModal,
  handleContinue,
}: {
  isOpen: boolean;
  onClose: () => void;
  currentModal: string;
  handleContinue: () => void;
}) => {
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries, assets } = contentfulData;
  const contents = entries?.rb_change_pin;

  const title =
    currentModal == 'change-pin'
      ? contents?.webChangePinAndActivateCardInfoModal?.infoModalTitle_changePin
      : contents?.webChangePinAndActivateCardInfoModal
          ?.infoModalTitle_activateCard;

  if (!isOpen) return null;
  return (
    <CommanModal
      isOpen={isOpen}
      width="md:max-w-[530px] max-w-full"
      height="md:h-auto h-[100vh]"
      jsxContent={
        <>
          <div
            aria-label={title}
            className="mt-[20px] md:text-[22px] text-[16px] font-semibold md:text-center text-start"
          >
            {renderDescriptionParagraphs(title, ' ')}
          </div>
          <div className="mt-[20px]">
            <ul className="list-disc font-normal mt-2 text-[14px] text-gray-700 leading-5 md:px-11 px-6">
              <li
                aria-label={
                  contents?.webChangePinAndActivateCardInfoModal?.modalContent[
                    '1'
                  ]
                }
                className="mb-4"
              >
                {renderDescriptionParagraphs(
                  contents?.webChangePinAndActivateCardInfoModal?.modalContent[
                    '1'
                  ],
                  ' '
                )}
              </li>
              <li
                aria-label={
                  contents?.webChangePinAndActivateCardInfoModal?.modalContent[
                    '2'
                  ]
                }
                className="mb-4"
              >
                {renderDescriptionParagraphs(
                  contents?.webChangePinAndActivateCardInfoModal?.modalContent[
                    '2'
                  ],
                  ' '
                )}

                {renderDescriptionParagraphs(
                  contents?.webChangePinAndActivateCardInfoModal?.modalContent[
                    '3'
                  ],
                  ' '
                )}
              </li>
              <li
                aria-label={
                  contents?.webChangePinAndActivateCardInfoModal?.modalContent[
                    '4'
                  ]
                }
                className="mb-4"
              >
                {renderDescriptionParagraphs(
                  contents?.webChangePinAndActivateCardInfoModal?.modalContent[
                    '4'
                  ],
                  ' '
                )}

                {renderDescriptionParagraphs(
                  contents?.webChangePinAndActivateCardInfoModal?.modalContent[
                    '5'
                  ],
                  ' '
                )}
              </li>
            </ul>
          </div>
          {/* //<div className=" "/> */}
        </>
      }
      onClose={() => {
        onClose();
      }}
      buttonText={contents?.changePin?.cancel}
      cardStatus={true}
      closeIcon={true}
      extraButtonText={contents?.changePin?.continue}
      onExtraButtonClick={() => {
        handleContinue();
      }}
      buttonClassName="md:relative md:flex-row fixed bottom-0 w-full left-0 p-5 border md:border-none bt-[#E9E9E9] bg-[#FAFAFA] md:bg-white"
      onCloseIconClick={() => {
        onClose();
      }}
      customStyle={'fixed bottom-0 width-full left-0 p-5'}
    />
  );
};

export default ChangePinInfoModal;
